var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerVersa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 53,
    viewBox: "0 0 186 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_1494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.316 13.2178H106.322V17.3707H91.0569V24.242H104.584V28.3949H91.0569V35.4951H106.516V39.648H86.316V13.2178Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.881 13.2178H122.91C126.3 13.2178 128.961 14.2002 130.693 15.8636C132.118 17.2981 132.927 19.263 132.927 21.5627V21.6408C132.927 25.9835 130.266 28.5903 126.528 29.6453L133.81 39.6536H128.181L121.554 30.4435H115.616V39.6536H110.875V13.2178H110.881ZM122.562 26.3185C125.953 26.3185 128.112 24.5825 128.112 21.9032V21.825C128.112 18.995 126.032 17.4433 122.522 17.4433H115.622V26.3185H122.562Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.856 35.7965L138.711 32.4752C141.292 34.6633 143.913 35.9137 147.23 35.9137C150.158 35.9137 152.01 34.5517 152.01 32.5925V32.5199C152.01 30.6332 150.933 29.6117 145.919 28.4786C140.175 27.1166 136.939 25.4588 136.939 20.5858V20.5077C136.939 15.9752 140.791 12.8438 146.153 12.8438C150.084 12.8438 153.207 14.0159 155.942 16.165L153.401 19.676C150.973 17.9009 148.546 16.9576 146.079 16.9576C143.304 16.9576 141.685 18.3531 141.685 20.089V20.1672C141.685 22.2046 142.916 23.1144 148.124 24.3201C153.828 25.6765 156.757 27.6804 156.757 32.0622V32.1403C156.757 37.0859 152.785 40.0331 147.121 40.0331C142.996 40.0331 139.104 38.6376 135.867 35.802L135.856 35.7965Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.862 39.6482H162.717L165.492 33.2681H178.251L180.986 39.6482H185.994L174.871 14.7083C174.381 13.6031 173.242 12.8384 171.926 12.8384C170.609 12.8384 169.475 13.6031 168.98 14.7083L157.851 39.6482H157.862ZM167.287 29.1486L171.92 18.4984L176.49 29.1486H167.287Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5177 38.1744C67.9793 39.2684 69.0506 40.0331 70.3155 40.0331C71.5805 40.0331 72.6461 39.2908 73.102 38.2135L83.598 13.2178H78.4525L70.2928 34.0103L62.1444 13.2178H56.9989L67.5177 38.1744Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0749 19.3971C22.9466 22.6178 12.8722 17.3374 4.09698 13.4859C2.70662 12.8774 1.40744 13.4412 0.831922 14.044C-0.729379 15.6739 0.381766 17.4322 0.381766 17.4322L20.1601 50.985C20.1601 50.985 21.1117 52.8661 23.3967 52.8661C24.4566 52.8661 25.8127 52.4362 26.6504 50.985L26.9809 50.4268V17.2369C26.9809 18.2137 26.5592 18.9003 26.0806 19.3971H26.0749Z",
    fill: "url(#paint0_linear_205_1494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8419 7.06113C40.8845 1.4011 28.8955 -1.14982 24.4338 0.491256C20.9921 1.75276 18.7755 5.39773 23.5278 11.3201C26.0293 14.4404 26.9809 15.8582 26.9809 17.2369V50.4212L46.5143 17.276C48.9132 12.7547 48.2294 9.77951 45.8476 7.06113H45.8419Z",
    fill: "url(#paint1_linear_205_1494)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_1494",
    x1: -2.72944,
    y1: 33.0448,
    x2: 27.2316,
    y2: 33.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_1494",
    x1: 20.9465,
    y1: 25.2078,
    x2: 48.1553,
    y2: 25.2078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerVersa);
export default __webpack_public_path__ + "static/media/partner_versa.f68a4f0211cd72ee88f0ea2e6e52ac7c.svg";
export { ForwardRef as ReactComponent };